"use client"

import { Component } from "react"
import moment from "moment"
import { URL_PATH } from "../../services/API"
import API from "../../services/API"
import redux from "../../common/Redux"
import Table from "../../components/Table"
import Header from "../../components/Header"
import Modal from "../../components/Modal"
import Toast from "../../components/Toast"
import { root_url } from "../../services/API"
import routes from "../../routes/URL"
import { getCurrency } from "../../common/util"

class CouponListScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      version: 1,
      loading: true,
      error: null,
      modleVisible: false,
      modalData: null,
      couponData: null,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
    this.getAllCoupons()
  }

  getAllCoupons = async () => {
    console.log(this.props.selectedHotelId.currency)
    console.log("Fetching coupons for hotel:", URL_PATH.listAllCoupons)
    const res= await API(this, "get", URL_PATH.listAllCoupons(this.props.selectedHotelId.id))
    console.log("Coupons Response:", res )
  }

  handleToastClose = () => {
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  onEdit = async (item) => {
    this.props.history.push(routes.admin.coupon.update(this.props.hotels[0].hotel_slug,item.slug,item.id));

    // console.log("Delete coupon:", item)
    // const { status, message } = await API(this, "post", URL_PATH.updateCoupon(item.id))

    // if (status === "success") {
    //   this.showToast(message, "success")
    //   this.setState({
    //     version: this.state.version + 1,
    //   })
    // } else {
    //   this.showToast(message, "error")
    // }
  }

  onView = async (item) => {
    console.log("View coupon details:", item)
    this.setState({
      modalData: item,
      modleVisible: true,
    })
  }

  onDelete = async (item) => {
    console.log("Delete coupon:", item)
    const { status, message } = await API(this, "post", URL_PATH.deleteCoupon,{coupon_id:item.id})

    if (status) {
      this.showToast(message, "success")
      this.setState({
        version: this.state.version + 1,
      })
    } else {
      this.showToast(message, "error")
    }
  }

   onSwitch = async (item, value) => {
  console.log("Coupon: ", item);
  const { status, message, data } = await API(
    this,
    "post",
    URL_PATH.updateCouponStatus,
    {
      coupon_status: value ? "1" : "0", // Changed from table_status_on_off to coupon_status
      coupon_id: item.id // Added coupon_id as required by API
    }
  );
  
  if (status) { // Changed from status === "success" to just status (as Postman shows boolean status)
    this.showToast(message || "Coupon status updated successfully", "success");
    // Refresh the table data
    this.setState({ version: this.state.version + 1 });
  } else {
    this.showToast(message || "Failed to update coupon status", "error");
  }
}

//   toggleCouponStatus = async (item) => {
//     console.log("Toggle coupon status:", item)
//     const newStatus = item.status === "active" ? "inactive" : "active"
//     const { status, message } = await API(
//       this,
//       "post",
//       URL_PATH.updateCouponStatus(item.id),
//       { status: newStatus }
//     )

//     if (status === "success") {
//       this.showToast(`Coupon status updated to ${newStatus}`, "success")
//       this.setState({
//         version: this.state.version + 1,
//       })
//     } else {
//       this.showToast(message, "error")
//     }
//   }

  render() {
    const { modalData, modleVisible, toast } = this.state

    return (
      <div className="container-fluid">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Header title="Coupons" />
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div
              className="btn"
              style={{ backgroundColor: "#FFC857", color: "#000", fontWeight: "700" }}
              onClick={() => {
                // Navigate to create coupon page
                this.props.history.push(routes.admin.coupon.create(this.props.hotels[0].hotel_slug))
              }}
            >
              +ADD COUPON
            </div>
          </div>
        </div>

        <Table
  key={this.state.version}
  // export={true}
  api={URL_PATH.listAllCoupons(this.props.selectedHotelId.id)}
  onEdit={this.onEdit}
  onView={this.onView}
  deleteText="Delete Coupon will remove it permanently"
  searchPlaceholder="Search by code"

  onDelete={this.onDelete}
  row={[
    { 
      title: "Code", 
      key: "coupon_code",  // Changed from 'code' to match response
      sortable: true 
    },
    { 
      title: "Discount", 
      key: "coupon_discount_value",  // Changed from 'discount'
      sortable: true,
      render: (item) => `${item.coupon_discount_value} ${item.coupon_discount_type === 'percentage' ? '%' : ''}`
    },
    { 
      title: "Type", 
      key: "coupon_type",  // Changed from 'discount_type'
      sortable: true,
      render: (item) => {
        const types = {
          'one_time': 'One Time',
          'multiple_time': 'Multiple Use',
          'first_time': 'First Time',
          'once_a_month': 'Once a Month'
        };
        return types[item.coupon_type] || item.coupon_type;
      }
    },
    
     
    { 
      title: "Min Order", 
      key: "coupon_min_order_amount", 
      sortable: true,
      parse: (item) => {
        return `${getCurrency(this.props.selectedHotelId.currency)} ${item.coupon_min_order_amount}`;
      }
    },
    { 
      title: "Max Discount", 
      key: "coupon_max_discount_amount", 
      sortable: true,
      parse: (item) => {
        return `${getCurrency(this.props.selectedHotelId.currency)} ${item.coupon_max_discount_amount}`;
      }
    },
    
    { 
      title: "Description", 
      key: "coupon_description", 
      sortable: true 
    },
    {
              title: "Status",
              key: "coupon_status",
               type: "switch",
              sortable: true,
              onSwitch: this.onSwitch,

            },
  ]}
/>

  {modleVisible && modalData && (
  <Modal
    visible={modleVisible}
    onClose={() => {
      this.setState({
        modleVisible: false,
        modalData: null,
      });
    }}
    title={`Coupon Details: ${modalData?.coupon_code}`}
    style={{ 
      overflow: 'hidden',
      maxHeight: '80vh',
    }}
  >
    <div
      style={{
        padding: "15px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        maxHeight: "calc(70vh - 60px)",
        overflowY: "auto",  // Ensures scrolling works
        overflowX: "hidden",
        // Scrollbar styling (works in some browsers)
        scrollbarWidth: "thin", // For Firefox
        scrollbarColor: "rgba(0,0,0,0.2) transparent", // For Firefox
      }}
    >
      {/* Content remains the same */}
      <div style={{ marginBottom: "15px" }}>
        <h4>Basic Information</h4>
        <p><strong>Code:</strong> {modalData?.coupon_code}</p>
        <p>
          <strong>Discount:</strong> {modalData?.coupon_discount_value}
          {modalData?.coupon_discount_type === "percentage" ? "%" : "₹"}
        </p>
        <p><strong>Discount Type:</strong> {modalData?.coupon_discount_type}</p>
        <p><strong>Max Discount:</strong> ₹{modalData?.coupon_max_discount_amount}</p>
        <p><strong>Status:</strong> 
          <span
            style={{
              backgroundColor: modalData?.status === "active" ? "#00A651" : "#FF0000",
              color: "#fff",
              padding: "4px 8px",
              borderRadius: "12px",
              fontSize: "12px",
              fontWeight: "bold",
              marginLeft: "10px",
            }}
          >
            {modalData?.status || "N/A"}
          </span>
        </p>
      </div>

      <div style={{ marginBottom: "15px" }}>
        <h4>Validity</h4>
        <p><strong>Start Date:</strong> {moment(modalData.start_date).format("DD-MM-YYYY")}</p>
        <p><strong>End Date:</strong> {moment(modalData.end_date).format("DD-MM-YYYY")}</p>
        <p><strong>Minimum Order:</strong> ₹{modalData?.coupon_min_order_amount || "No minimum"}</p>
      </div>

      <div style={{ marginBottom: "15px" }}>
        <h4>Usage</h4>
        <p><strong>Coupon Type:</strong> {modalData?.coupon_type}</p>
        <p><strong>Value for Coupon Type:</strong> {modalData?.value_for_coupon_type}</p>
        <p><strong>Hotel ID:</strong> {modalData?.hotel_id}</p>
      </div>

      {modalData?.coupon_description && (
        <div>
          <h4>Description</h4>
          <p>{modalData?.coupon_description}</p>
        </div>
      )}
    </div>
  </Modal>
)}

        <Toast
          open={toast.open}
          message={toast.message}
          severity={toast.severity}
          handleClose={this.handleToastClose}
        />
      </div>
    )
  }
}

export default redux(CouponListScreen)